var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadeMorerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more\\u767D\\u8272",
    transform: "translate(-234 -82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_12469",
    "data-name": "\\u7EC4 12469",
    transform: "translate(237 85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_16487",
    "data-name": "\\u77E9\\u5F62 16487",
    width: 24,
    height: 24,
    transform: "translate(-3 -3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "more",
    transform: "translate(225.5 73.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(19 19)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(24 19)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(14 19)",
    fill: "#000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadeMorerIcon);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0ibW9yZeeZveiJsiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzNCAtODIpIj4KICAgIDxnIGlkPSLnu4RfMTI0NjkiIGRhdGEtbmFtZT0i57uEIDEyNDY5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzcgODUpIj4KICAgICAgPHJlY3QgaWQ9IuefqeW9ol8xNjQ4NyIgZGF0YS1uYW1lPSLnn6nlvaIgMTY0ODciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTMpIiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0ibW9yZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjI1LjUgNzMuNSkiPgogICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMS41IiBjeT0iMS41IiByPSIxLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5IDE5KSIgZmlsbD0iIzAwMCIvPgogICAgICA8Y2lyY2xlIGlkPSJPdmFsLTIiIGRhdGEtbmFtZT0iT3ZhbCIgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNCAxOSkiIGZpbGw9IiMwMDAiLz4KICAgICAgPGNpcmNsZSBpZD0iT3ZhbC0zIiBkYXRhLW5hbWU9Ik92YWwiIGN4PSIxLjUiIGN5PSIxLjUiIHI9IjEuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQgMTkpIiBmaWxsPSIjMDAwIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };